import React, { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import "../../../scss/dashboard/abogadosForm.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DragZone from "../../DragZone";
import { getFileSize } from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useFileUpload from "../../../api/hooks/useFileUpload";
import LoadingButton from "../../LoadingButton";
import { useRequestCustomTemplate } from "../../../api/hooks/templates";
import { usePublicTemplateList } from "../../../api/hooks/public-templates";

// const DragDocument = ({ formState }) => {
//   const history = useHistory();
//   const { register, errors, handleSubmit } = useForm();

//   const onSubmit = (data) => {
//     console.log(data);
//     history.push("/dashboardabogados/misPlantillas");
//   };

//   useEffect(() => {
//     console.log(formState);
//   }, []);

//   return (
//     <Fragment>
//       <div>
//         <UploadPdf />
//       </div>
//     </Fragment>
//   );
// };

// export default DragDocument;

const UploadPdf = ({ isRequestingTemplate, onSubmit }) => {
  const { t } = useTranslation("common");
  const [files, setFiles] = useState([]);
 
  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      // const categories = parseCategories(formState.two)
      onSubmit(null, {
        fileId,
        url
      })
      // console.log({formState})
      // const payload = {
      //   type: 'lawyers',
      //   name: formState.one.nombrePlantilla,
      //   description: formState.one.descripcion,
      //   price: formState.two.Precio,
      //   bankData: {
      //     name: formState.three.nombreBanco,
      //     accountOwnerName: formState.three.nombre,
      //     standarizedBankCode: formState.three["Cuenta Clave"]
      //   },
      //   categories,
      //   fileId,
      //   url,
      // }
      // mutateRequestTemplate(payload);
    },
    onError: (error) => {
      toast.error(
        t(`errors.${error?.message}`, t("errorMessages.generalError"))
      );
    },
  });

  const handleDrop = useCallback((acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) => {
        const fileSize = getFileSize(file.size);

        return Object.assign(file, {
          fileSize: `${fileSize.amount.toFixed(2)} ${fileSize.type}`,
        });
      })
    );
  }, []);


  const handleSubmit = () => {
    window.scrollTo(0, 0);

    uploadFile({ file: files[0] })
  };

  return (
    <>
      <h3>Sube tu Plantilla</h3>
      <div className="modal-height mt-5">
        <div className="mb-2 mt-4">
          {/* <p className="font-weight-bold">
            Tu archivo deberá estar formato PDF
          </p>
          <div className="p-2">
            <FontAwesomeIcon
              className="text-accent"
              icon="file-alt"
              size="3x"
            />
          </div> */}
        </div>
        {files?.map((file) => (
          <div
            className="d-flex mb-1 mr-1 align-items-center justify-content rounded p-3 bg-grey"
            key={file.name}
          >
            <FontAwesomeIcon className="color-accent" icon="file" size="2x" />
            <div className="d-flex flex-column ml-3">
              <span>{file.name}</span>
              <span className="text-muted">{file.fileSize}</span>
            </div>
          </div>
        ))}

        {!files?.length && (
          <DragZone
            multiple={false}
            // imgSrc="/images/listing/createDocument/subir.svg"
            label={"  Arrastra y sube tus documentos o haz clic para cargar"}
            className="frontdesk-drag bg-indigo-10 mt-4"
            acceptedFiles={["application/pdf"]}
            // noClick={() => { }}
            version={2}
            icon="cloud-upload-alt"
            // handleFile={onDrop}
            onDrop={handleDrop}
          />
        )}
      </div>
      <div>
        <div className="mx-auto mt-5">
          <LoadingButton
            className="ml-2"
            color="accent-100"
            onClick={handleSubmit}
            loading={uploadFileState.isLoading || isRequestingTemplate}
            loadingText={t("actions.uploading")}
            disabled={files?.length < 1}
          >
            Guardar
          </LoadingButton>
        </div>
      </div>
    </>
  );
};
export default UploadPdf;
